import $ from 'jquery';
import { getUrlParam } from './url-helper';
import { onLoad } from './onLoad';

const showModalOnLoad = () => {
    const modalId = getUrlParam( 'load-modal' );

    if ( modalId !== false && modalId ) {
        onLoad( () => $( '#' + modalId ).modal( 'show' ) );
    }
};

export { showModalOnLoad };
